import axios from 'axios';

import {UPDATE_USER} from "./types";
import { createMessage, returnErrors } from "./messages";
import { tokenConfig} from "./auth";
import { getCustomers } from "./customers";

// UPDATE USER
export const updateUser = (user) => (dispatch, getState) => {
    axios.patch(`/api/v1/users/${user.id}/`, user,tokenConfig(getState))
        .then(res => {
            dispatch(getCustomers());
        }).catch(err => console.log(err));
};